import { render, staticRenderFns } from "./ctrlobs3Mensajes.vue?vue&type=template&id=bec1f0e6&scoped=true"
import script from "./ctrlobs3Mensajes.vue?vue&type=script&lang=js"
export * from "./ctrlobs3Mensajes.vue?vue&type=script&lang=js"
import style0 from "./ctrlobs3Mensajes.vue?vue&type=style&index=0&id=bec1f0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec1f0e6",
  null
  
)

export default component.exports